import React, { type FC } from 'react';

import { LoadableAfterPaint, useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';
import { useIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/useIsNav4Enabled.ts';

import { NAV4_POPOVER_OFFSET } from '../CreateContentPopover/ContextualCreateContentPopover/ContextualCreateContentPopover.tsx';

export const ContextualCreateContentPopoverLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextualCreatePopover" */ '../CreateContentPopover/index.ts'
			)
		).ContextualCreateContentPopover,
});

type TreeBottomCreateButtonProps = {
	spaceKey: string;
	source: string;
};

export const TreeBottomCreateButton: FC<TreeBottomCreateButtonProps> = ({ spaceKey, source }) => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();
	const isNav4Enabled = useIsNav4Enabled();

	const offset: [number, number] = isNav4Enabled ? NAV4_POPOVER_OFFSET : [0, 6];

	return (
		<div
			data-testid="page-tree-create-button"
			data-vc="page-tree-create-button"
			{...ssrPlaceholderIdProp}
		>
			<ContextualCreateContentPopoverLoader
				spaceKey={spaceKey}
				source={source}
				isTreeItem
				offset={offset}
				placement="bottom-start"
				shouldRenderToParent
			/>
		</div>
	);
};
